import { render, staticRenderFns } from "./PieDump.vue?vue&type=template&id=5d6f70eb&scoped=true"
import script from "./PieDump.vue?vue&type=script&lang=js"
export * from "./PieDump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f70eb",
  null
  
)

export default component.exports